module.exports = __webpack_public_path__ + "static/img/143_phase_function_Paper_Points.1639600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/143_phase_function_Paper_Points.png
// module id = /sLv
// module chunks = 0